import CommunityPage from './community_page';

export default function(/* store */) {
  return {
    path: '/community-spot-im',
    component: CommunityPage,
    exact: true,
    strict: true
  };
}



// WEBPACK FOOTER //
// ./src/views/containers/pages/community_page/community_route.js